export { useGetFipsCode } from './useGetFipsCode';
